import cx from 'classnames';
import React from 'react';
import { Vertical } from '../../../../layout/flex-layout/flex-layout';
import { Typography } from '../../../../typography';
import styles from './action-column.module.scss';
export const ActionColumn = React.memo(({ data, colDef, actions }) => {
    let actionColumn;
    if (actions) {
        actionColumn = {
            id: data.id,
            actions: {
                ...actions,
            },
        };
    }
    else {
        const fieldValues = data[(colDef === null || colDef === void 0 ? void 0 : colDef.field) || 'action'];
        actionColumn = {
            ...fieldValues,
        };
    }
    const onClick = (event, item) => {
        const menuItemEvent = {
            id: item.id,
            label: item.label || '',
            event,
            data,
        };
        if (item.onClick) {
            item.onClick(menuItemEvent);
        }
    };
    return (React.createElement(Vertical, { className: styles.actionColumnContainer, "data-testid": "action-column-testid" }, actionColumn.actions[0].items.map((item) => (React.createElement(Typography, { variant: "p", overrideTag: "div", className: cx(styles.actionItem, {
            [styles.disabled]: item.itemDisabled,
        }), onClick: (e) => {
            if (!item.itemDisabled) {
                onClick(e, item);
            }
        }, key: item.id, tooltipConfig: {
            dataTooltipContent: item.itemDisabled
                ? item.itemDisabledTooltip || ''
                : item.label || '',
        } }, item.label)))));
});
//# sourceMappingURL=action-column.js.map